import React from 'react'
import FeatureTabWrapper from './FeatureTabWrapper'
import FeatureTabContent from './FeatureTabContent'

const FilteredArticles = () => {
  const categories = [
    { id: '1', name: 'Quốc tế', slug: 'tin-quoc-te' },
    { id: '2', name: 'Mới nhất', slug: '' },
  ]
  return (
    <>
      <FeatureTabWrapper categories={categories}>
        {(activeTab) => <FeatureTabContent slug={activeTab} />}
      </FeatureTabWrapper>
    </>
  )
}

export default FilteredArticles
